import { KEY_GENERATOR } from "../../../functions/funtion";
import SectionSliderImage from "./image-slider/section-image-slider";
import ViewProdutSection from "./horizontal-view-product-section/view-product-section";
import ClickbleBanner from "./banner-clickable/banner-clickable";
import ViewSection from "./horizontal-view-section/view-section";
import React from "react";
import { CSP } from "../../../config/config";

export default class Sections extends React.PureComponent {
  render() {
    return (
      <>
        {this.props.data.map((rs, index) => {
          let DataSection = JSON.parse(rs.DATA);
          if (DataSection.length > 0) {
            let key = KEY_GENERATOR() + index;
            if (rs.TYPE === 1) {
              return (
                <ViewSection
                  pmData={DataSection}
                  Name={rs.NAME}
                  key={key}
                  navigate={this.props.navigate}
                  displayFav={false}
                  refreshHome={this.props.refreshHome}
                />
              );
            } else if (rs.TYPE === 2) {
              return (
                <ViewProdutSection
                  pmData={DataSection}
                  Name={rs.NAME}
                  key={key}
                  navigate={this.props.navigate}
                />
              );
            } else if (rs.TYPE === 3 && CSP !== 'MK') {
              return (
                <ClickbleBanner
                  pmData={DataSection}
                  Name={rs.NAME}
                  key={key}
                  navigate={this.props.navigate}
                />
              );
            } else if (rs.TYPE === 4) {
              return (
                <SectionSliderImage
                  pmData={DataSection}
                  Name={rs.NAME}
                  key={key}
                  navigate={this.props.navigate}
                />
              );
            }
          } else {
            return <React.Fragment key={KEY_GENERATOR()} />;
          }
        })}
      </>
    );
  }
}
